export enum ProductType {
    ConsumerLoan = 0,
    CreditCard = 1,
    Mortgage = 2
}
